var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_24_682",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_24_682",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEhUlEQVR4nO2dS4ucRRSGD3gN8bJVI6iofyDqKkqLqMxqtBvetxqndYwms4kwiZKMy+zUrMKAfyNqXET0BygS8ZKNm9GNFzQmE1fOQJKSw9RAaLpjj1P1nfq6zwMHGvpW9XZ1Xc53zvlEHMdxHMdxHMdxnMkAcAvJpwC8SfIUgI9J/kByDcBlkptq6fGaPqevAfCBvqff7z+pnzHh180W3W73QZJHAXwK4G+ScZd2BcBZAMsA9sksA2APgFcBfAHgWgZxx9lVkp8DGCwuLt4pswKAu9JI+7WguOPsTwAnAdwr08rS0tJtAI6TvGQg8LBpG97RNsk0EUJ4BsCFCgQeth9JPi9tR+dEAB+SvF6BqOPsOoDVubm5O6SNhBAeBvBVBULGSQzANwAekzahf8dM27TYsOm28DlpAwC6AP6pQLT4P00PQ0FqBsBS4T1xbMK0DwAOS42QfDkdDsyFYj6xKTWh8xrJDWtxmN82QwgvSg30er3HW7rwxQntSgjhUVORde+p26IKxIiF7bzpPjsdRuIsGIBVs2N15Se+WOAE2WlU5E6ncyuA7yvofGx4VF9o1BGVvHAWB4nj3W73fjWSJ9LVlqbFPtaIyPPz83cbuTpPjPjBVwyEvqg+9eJCW3SOZNRRPKIt91m0RX3Zxd2eJH+z6JyMwUjo3/VSXDGhSb5m1LFYmdA6hbxSTGi9kOpCc1vsc6VE3mfpNJL6RvS1IqEMGndh1SlWKHQS+63sQmtwiwvNYbHPlAjTWnehOSz0etbwM42FsxSZlU4dafp4IqfQh6w7JJUKTfJgTqFPWXdI6hX6vZxCf2LdIalX6HwLYg0uUalX6G9zCv1zblenGFHAxfpTtsaR/KuUq9OKXF5IdZtma1SuX79rOJILulg3qhO63+8/IJWQfDfVCZ1l6gCwIpUA4N3qpo7Mi+GK5cjW707zc32LoW/v2Mz2zg8sbObA4kdwNnMET1ms0dJk/CAwbReA17MJ7W5S3kzs/dmEdsc/m3H8J7HP+tTBcgvhDUIvu9Acnp+PFNnoe7gBbxT6qvpLpARaJcB3HSwbQKNo2QcXmuVDwlJut0X5hziuTVMZ5GgYhB5HOaIyujp3ZADelmkNRMcIF2suV+cO23FxMBjslSbQQGyDkbS57WIt4OrcidDL0nCy0HcGYseZShZSADzt6W8NoUmO1qOMzdlpsULTdjV9dwamjK8B3C6WaEK6JqZbi8GyHrpHpAZCCM+2vOpMvMlO5wWpiRDCS9NWGCWEAKkRLY8zDaV+uDVgDknNaMmflk8jG9WV+PmP0j9tXCDXdb2RNtHr9R4C8GUF4sUJ7bx5SZ9dlgJarfwEqW07bb5PznVcRwVZA8OW2nRAponOliPqmLoZKxBYa24sa5tkWhkMBnvTFfVfDET+Qwt1Lyws3COzwuJW7Y8FAJ8VPujoZ5/Ta3wzVXp+FJpyoQnsAD5Kd6PY7dRwOX3WkWIhAW0HW3nn+wG8QfJ9jQbSGOR0K5BL27cHSY/X0nNn0msPpvf67UEcx3Ecx3Ecx3FkQv4Fp+px1sQXbnIAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.f6026f3910fbf0b6bd0ef11e9fe72108.svg";
export { ForwardRef as ReactComponent };